import React, {PropsWithChildren, useState} from 'react';
import {Container} from '@mui/material';
import {Vazirmatn} from "next/font/google";
import {Row} from "@/core/general/row.component";
import {ColumnProps} from "@/core/general/column.component";

const vazirmatn = Vazirmatn({ subsets: ['arabic'],variable:'--vazirmatn' });

interface DrawerProps {
  className?: string;
}

export default function LayoutDrawer(props: PropsWithChildren<DrawerProps>){

    const [theme, setTheme] = useState<'light' | 'dark'>(() => {
        if (typeof document !== 'undefined') {
            return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
        }
        return 'light';
    });

  return (
    <Row className={`totalCenter ${props.className} ${vazirmatn.className} font hideScrollBar`}>
      <Container fixed={true} maxWidth={'md'} className={'!flex flex-col totalCenter'} disableGutters={true}>
        <div className={`AppDrawer ${theme=='dark' ?"dark":"light"} center w-full md:w-3/4 lg:w-1/2`}>
          <div className="w-full hideScrollBar relative">{props.children}</div>
        </div>
      </Container>
    </Row>
  );
};
